<template>
    <b-modal :active="active" @close="close">

        <div class="modal-card">
            <div class="modal-card-head">
                <div class="modal-card-title">
                    Занятие уже существует у некоторых студентов
                </div>
            </div>

            <div class="modal-card-body">

                <b-message type="is-warning" has-icon>
                    Для студентов уже существуют занятия на это время.
                </b-message>

                <b-table
                    striped
                    class="is-size-7"
                    :data="students">

                    <template slot-scope="props">

                        <b-table-column
                            field="student_type"
                            label="Вид подготовки">
                            {{ $t(`students.type.${props.row.profile.type}`) }}
                        </b-table-column>

                        <b-table-column
                            field="course"
                            centered
                            label="Курс">
                            {{ props.row.profile.course }}
                        </b-table-column>

                        <b-table-column
                            field="name"
                            label="ФИО">
                            {{ props.row.full_name }}
                        </b-table-column>

                        <b-table-column
                            centered
                            label="Группа">
                            <a :href="$_.get(
                                props.row.profile,
                                'regular_group.url'
                            )"
                            target="_blank">
                            {{ $_.get(
                                props.row.profile, 
                                'regular_group.title'
                            ) }}
                            </a>
                            <span
                                v-if="hasGroup($_.get(
                                    props.row.profile, 
                                    'regular_group'
                                ))">
                                <i class="mdi mdi-alert has-text-warning"></i>
                            </span>
                        </b-table-column>

                        <b-table-column
                            label="Первый язык">
                            <a :href="$_.get(
                                props.row.profile,
                                'primary_language_group.url'
                            )"
                            target="_blank">
                            {{ $_.get(
                                props.row.profile, 
                                'primary_language_group.title'
                            ) }}
                            </a>
                            <span
                                v-if="hasGroup($_.get(
                                    props.row.profile, 
                                    'primary_language_group'
                                ))">
                                <i class="mdi mdi-alert has-text-warning"></i>
                            </span>
                        </b-table-column>

                        <b-table-column
                            label="Второй язык">
                            <a :href="$_.get(
                                props.row.profile,
                                'secondary_language_group.url'
                            )"
                            target="_blank">
                            {{ $_.get(
                                props.row.profile, 
                                'secondary_language_group.title'
                            ) }}
                            </a>
                            <span
                                v-if="hasGroup($_.get(
                                    props.row.profile, 
                                    'secondary_language_group'
                                ))">
                                <i class="mdi mdi-alert has-text-warning"></i>
                            </span>
                        </b-table-column>

                        <b-table-column
                            :visible="studentType == 'bachelor'"
                            centered
                            label="Кафедра">
                            <a :href="$_.get(
                                props.row.profile,
                                'bachelor_group.url'
                            )"
                            target="_blank">
                            {{ $_.get(
                                props.row.profile, 
                                'bachelor_group.title'
                            ) }}
                            </a>
                            <span
                                v-if="hasGroup($_.get(
                                    props.row.profile, 
                                    'bachelor_group'
                                ))">
                                <i class="mdi mdi-alert has-text-warning"></i>
                            </span>
                        </b-table-column>

                        <b-table-column
                            :visible="studentType == 'master'"
                            centered
                            label="Программа">
                            <a :href="$_.get(
                                props.row.profile,
                                'master_group.url'
                            )"
                            target="_blank">
                            {{ $_.get(
                                props.row.profile, 
                                'master_group.title'
                            ) }}
                            </a>
                            <span
                                v-if="hasGroup($_.get(
                                    props.row.profile, 
                                    'master_group'
                                ))">
                                <i class="mdi mdi-alert has-text-warning"></i>
                            </span>
                        </b-table-column>

                        <b-table-column
                            :visible="studentType == 'bachelor'"
                            centered
                            label="Курс по выбору">
                            <a :href="$_.get(findOptionalGroup(props.row), 'url')"
                            target="_blank">
                            {{ $_.get(findOptionalGroup(props.row), 'title') }}
                            </a>
                            <span
                                v-if="hasGroup(findOptionalGroup(props.row))">
                                <i class="mdi mdi-alert has-text-warning"></i>
                            </span>
                        </b-table-column>

                    </template>

                </b-table>
                
            </div>

            <div class="modal-card-foot">
                <button class="button" @click="close">
                    <span class="icon">
                        <i class="mdi mdi-close"></i>
                    </span>
                    <span>Закрыть</span>
                </button>
            </div>
        </div>

    </b-modal>
</template>

<script>
export default Vue.extend({
  data() {
    return {
      active: false,
      students: [],
      groups: []
    };
  },
  methods: {
    findOptionalGroup(user) {
      let rowIndex = _.findIndex(this.students, { id: user.id });
      return _.find(_.get(user.profile, "optional_groups"), {
        id: this.groups[rowIndex],
      });
    },
    hasGroup(group) {
      return group && _.indexOf(this.groups, group.id) > -1;
    },
    open(students, type, groups) {
      this.students = students;
      this.studentType = type;
      this.groups = groups;
      this.active = true;
    },
    close() {
      this.active = false;
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/schedule/components/StudentIntersectionModal.vue